export type LinkifiedTextProps = {
    text: string;
}

const sanitize = (text: string) => {
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
};

const linkifyAndSanitize = (text: string) => {
    const escaped = sanitize(text)
    const urlRegex = /\bhttps?:\/\/[^\s]+/g
    return escaped.replace(urlRegex, (url) => {
        const safeUrl = url
        return `<a class='message_link' href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`
    });
};

export default function LinkifiedText({ text }: LinkifiedTextProps) {
    const html = linkifyAndSanitize(text);
    return <span dangerouslySetInnerHTML={{ __html: html }} />
}